// const radioButtons = document.querySelectorAll('.opt');
// console.log(radioButtons)

// radioButtons.forEach(btn => {
//       if (btn.checked) {
//         btn.nextElementSibling.classList.add('red')
//        }
//     btn.addEventListener('click', ()=>{
//         btn.nextElementSibling.classList.remove('red')
//         btn.nextElementSibling.classList.add('red')
//      })
// });

// var tooltips = document.querySelectorAll('.tooltiptext');
// var swatchWrapper = document.querySelectorAll('.swatch-image');

// for (i=0; i<= tooltips.length; i++){
//   swatchWrapper[i].addEventListener('mouseover', ()=>{
//     tooltips[i].style.visibility = 'visible';
//   })
//   swatchWrapper[i].addEventListener('mouseleave', ()=>{
//     tooltips[i].style.visibility = 'hidden';
//   })
// }

// console.log(tooltips)
// console.log(swatchWrapper)

var swatches = document.querySelectorAll(".swatch-image");

for (var i = 0; i < swatches.length; i++) {
  
  swatches[i].addEventListener("click", function (evt) {
    clearBlueFromButtons();
    evt.target.classList.add("are");
  });
}

function clearBlueFromButtons(){
  for (var i = 0; i < swatches.length; i++) {
    swatches[i].classList.remove("are");
  }
}
 





$(document).ready(function() {
  $('.section-block .grid.product-single').each(function(index) {
    const $block = $(this); 
    const blockQuantity = $block.attr('data-pack');
    const titleText = $block.find('.product-single__title').text();
    const match = titleText.match(/^(\d+)/); 
    // const totalQuantityLimit = match ? parseInt(match[1], 10) : 0; 
    const totalQuantityLimits = blockQuantity;
    const totalQuantityLimit = parseInt(totalQuantityLimits);
    $block.find('.js-qty input').val(0);

    let totalQuantity = 0;

    
    function updateTotalQuantity() {
      totalQuantity = 0; 
      $block.find('.js-qty input').each(function() {
        totalQuantity += parseInt($(this).val());
      });
     

      if (totalQuantity === totalQuantityLimit) {
        $block.find('.new-product-qty-template-button').prop('disabled', false); 
         console.log(totalQuantity + ' if: ' + totalQuantityLimit);
      } else {
        $block.find('.new-product-qty-template-button').prop('disabled', true); 
         console.log(totalQuantity + ' else: ' + totalQuantityLimit);
      }


      if (totalQuantity >= totalQuantityLimit) {
        $block.find('.js-qty__adjust--plus').prop('disabled', true);
      } else {
        $block.find('.js-qty__adjust--plus').prop('disabled', false);
      }
    }


    $block.on('click', '.js-qty__adjust--minus', function() {
      const $quantityInput = $(this).closest('.js-qty').find('input');
      let currentValue = parseInt($quantityInput.val());
      const $imageContainer = $block.find('.product-pack-placeholder-images'); // Scope to the current block
      const $images = $imageContainer.find('.default-image').get().reverse();

      if (currentValue > 0) { 
        $quantityInput.val(currentValue - 1);
        updateTotalQuantity();
        
        const selectedProperty = $quantityInput.attr('name');
        const propertyValue = selectedProperty.match(/\[(.*?)\]/)?.[1];
        const placeholderImage = $block.find('.product-single__info-wrapper').data('placeholder-image');
        console.log(`Property Value: ${propertyValue}`);

        // old code 
        // for (const img of $images) {
        //   const $img = $(img);
        //   const currentSrc = $img.attr('src');

        //   if (currentSrc.includes(propertyValue.replace(/\s+/g, '_'))) { 
        //     $img.attr('src', placeholderImage); 
        //     $img.removeClass("active-variant-image");
        //     console.log(`Updated image for property: ${propertyValue}`);
        //     break; 
        //   }
        // }

        // new code 
        for (const img of $images) {
          const $img = $(img);
          const activeVar = $img.attr("data-var-title");
          const normalizedVariant = propertyValue.toLowerCase().replace(/[\s\-_]+/g, '');

          if ($img.hasClass("active-variant-image") && activeVar === normalizedVariant) {
            $img.attr('src', placeholderImage);
            $img.removeClass("active-variant-image");
            $img.removeAttr("data-var-title");
            console.log("Image removed for variant:", propertyValue);
            break;
          }
        }

      } else {
        console.log('Quantity is already 0, cannot decrease further.');
      }
    });

    $block.on('click', '.js-qty__adjust--plus', function() {
      const $quantityInput = $(this).closest('.js-qty').find('input');
      let currentValue = parseInt($quantityInput.val());
      const $imageContainer = $block.find('.product-pack-placeholder-images'); 
      const $images = $imageContainer.find('.default-image');

      if (totalQuantity < totalQuantityLimit) {
        $quantityInput.val(currentValue + 1);
        updateTotalQuantity(); 
      }

      const selectedProperty = $quantityInput.attr('name');
      const propertyValue = selectedProperty.match(/\[(.*?)\]/)?.[1];
      console.log(propertyValue);
      const imageUrl = $block.find(`[data-var-title="${propertyValue}"]`).data('var-image-url');
      console.log(imageUrl);

      if (imageUrl) {
        $images.each(function() {
          const currentSrc = $(this).attr('src');
          if (currentSrc.includes('placeholder-image')) {
            $(this).attr('src', imageUrl);
            $(this).addClass("active-variant-image");
            // New Line Add
            $(this).attr("data-var-title", propertyValue.toLowerCase().replace(/[\s\-_]+/g, ''));
            return false; 
          }
        });
      }
    });
    updateTotalQuantity();
  });
  // $('.new-product-qty-template-variants').each(function(index) {
  // const $block = $(this);  // Current block
  // const qtySetValues = $block.attr('data-qty-set'); 
  // const qtySetValue = parseInt(qtySetValues, 10);  
  // const $plusButton = $block.find('.js-qty__adjust--plus'); 
  // console.log('set-qty for block ' + (index + 1) + ': ' + qtySetValue);
  // if (!isNaN(qtySetValue) && qtySetValue > 0) {
  //     let count = 0;
  //     const interval = setInterval(function() {
  //         $plusButton.click(); 
  //         count++;  
  //         if (count >= qtySetValue) {
  //             clearInterval(interval);  
  //         }
  //     }, 500);  
  // }
  // });

  // Target only inside product-single[data-pack="12"]
  $('.new-product-qty-template .product-single[data-pack="12"] .new-product-qty-template-variants').each(function (index) {
    const $block = $(this);
    const $plusButton = $block.find('.js-qty__adjust--plus');
    let count = 0;
    const interval = setInterval(function () {
      $plusButton.click();
      count++;
      if (count >= 3) { 
        clearInterval(interval);
      }
    }, 300);
  });

  $('.new-product-qty-template-variants').each(function (index) {
    const $block = $(this); // Current block
    const qtySetValues = $block.attr('data-qty-set');
    const qtySetValue = parseInt(qtySetValues, 10);
    const $plusButton = $block.find('.js-qty__adjust--plus');
    const $closestGrid = $block.closest('.grid.product-single'); // Closest grid.product-single

    // Determine behavior based on data-pack value
    const dataPack = $closestGrid.attr('data-pack');

    console.log('set-qty for block ' + (index + 1) + ': ' + qtySetValue);
    console.log('data-pack for block ' + (index + 1) + ': ' + dataPack);

    if (!isNaN(qtySetValue) && qtySetValue > 0) {
        let count = 0;

        const interval = setInterval(function () {
            if (dataPack === "12") {
                // Custom behavior for data-pack="12"
                if (qtySetValue === 3 && count < 6) {
                    $plusButton.click();
                } else if (qtySetValue === 1 && count < 2) {
                    $plusButton.click();
                }
            } else if (dataPack === "16") {
                // Custom behavior for data-pack="16"
                if (qtySetValue === 3 && count < 7) {
                    $plusButton.click();
                } else if (qtySetValue === 1 && count < 3) {
                    $plusButton.click();
                }
            } else {
                // Default behavior for other blocks
                $plusButton.click();
            }

            count++; // Increment the count
            if (
                (dataPack === "12" && qtySetValue === 3 && count >= 6) ||
                (dataPack === "12" && qtySetValue === 1 && count >= 2) ||
                (dataPack === "16" && qtySetValue === 3 && count >= 7) ||
                (dataPack === "16" && qtySetValue === 1 && count >= 3) ||
                (!["12", "16"].includes(dataPack) && count >= qtySetValue)
            ) {
                clearInterval(interval); // Stop interval after defined clicks
            }
        }, 500); // Interval time
    }
});

});















